import axios from './axios';

export async function subscribeNewsletter(email: string): Promise<void> {
  await axios.post('/newsletter/subscribe', { email });
}

export default {};
